module.exports = __webpack_public_path__ + "img/ic_back.c5c00003.svg";